var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Landing = (function (Landing) {

        Landing.Messages = (function (Messages) {

        Messages.Submit = function (competition ,email, firstname, lastname, message, newsletter, address, phones, mobiles, fax, gender, customxml, reCaptchaCode, terms) {
            var data = {
                competition: competition, 
                email: email,
                firstName: firstname,
                lastName: lastname,
                message: message,
                newsletter: newsletter,
                address: address,
                phones: phones,
                mobiles: mobiles,
                fax: fax,
                gender: gender,
                customxml: customxml,
                reCaptchaCode: reCaptchaCode,
                terms: terms
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Landing.Messages.Submit', data);
        };
        Messages.Submit.className = 'Vendd.Landing.Messages.Submit';

        Messages.SubmitSuccess = function (response) {
            response.data = JSON.parse(response.data);

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Landing.Messages.SubmitSuccess', response);
        };
        Messages.SubmitSuccess.className = 'Vendd.Landing.Messages.SubmitSuccess';

        Messages.SubmitFailure = function (response) {
            response.data = JSON.parse(response.data);

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Landing.Messages.SubmitFailure', response);
        };
        Messages.SubmitFailure.className = 'Vendd.Landing.Messages.SubmitFailure';

        return Messages;

        })(Landing.Messages || {});

        return Landing;

    })(Vendd.Landing || {});

return Vendd;

})(Vendd || {});